// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Products_establishments__2RUTN","header":"Products_header__13-_p","tableHeader":"Products_tableHeader__2i8wD"};